

// import React, { useState } from 'react';
// import { Link, useNavigate, useLocation } from 'react-router-dom';
// import sidebarMenuConfig from './sidebarMenuConfig';
// import '../css/HomeScreen.css';
// import { useAuth } from '../Constant/Auth';

// const Sidebar = () => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const { logout, roleId, libraryId } = useAuth(); // ✅ use context instead of localStorage
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleLogout = () => {
//     logout();
//     navigate('/login');
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const menuItems = sidebarMenuConfig[roleId] || [];

//   return (
//     <div className={`sidebar ${isSidebarOpen ? 'open' : 'collapsed'}`}>
//       <div className="sidebar-header">
//         <button className="toggle-button" onClick={toggleSidebar}>☰</button>
//         {isSidebarOpen && <div className="logo-text">Library Management</div>}
//       </div>

//       <ul className="sidebar-menu">
//         {menuItems.map((item, idx) => (
//           <li key={idx} className={location.pathname === item.path ? 'active' : ''}>
//             <Link to={item.path}>{item.label}</Link>
//           </li>
//         ))}
//       </ul>

//       {isSidebarOpen && (
//         <div className="sidebar-footer">
//           {/* {libraryId && <div className="library-info">Library ID: {libraryId}</div>} */}
//           {/* <button className="logout-button" onClick={handleLogout}>Logout</button> */}
//         </div>
//       )}
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import sidebarMenuConfig from './sidebarMenuConfig';
import '../css/HomeScreen.css'; // Your existing CSS
import { useAuth } from '../Constant/Auth'; // Your context for auth info
import { useActiveLibraryId } from '../Constant/useActiveLibrary';
import { prefetchLinkTarget } from './sidebarPrefetch';

const Sidebar = ({ mobileOpen = false, onClose = () => {} }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { logout, roleId, libraryId, user } = useAuth(); // useAuth must provide user info
  const activeLibraryId = useActiveLibraryId();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const menuItems = sidebarMenuConfig[roleId] || [];

  // ✅ Important: If user is inactive (status 0), hide sidebar
  if (!user || user.status !== 1) {
    return null;
  }

  return (
    <div className={`sidebar ${isSidebarOpen ? 'open' : 'collapsed'} ${mobileOpen ? 'mobile-open' : ''}`}>
      {/* Sidebar Header */}
      <div className="logo-container"><img src="https://jaipuria.edu.in/wp-content/uploads/2021/07/sajes_great_place_logo.jpg" alt="Logo" className="adminLogo" /></div>
      <div className="sidebar-header">
      
        <button className="toggle-button" onClick={toggleSidebar}>☰</button>
        {isSidebarOpen && <div className="logo-text">Library Management</div>}
      </div>

      {/* Sidebar Menu */}
      <ul className="sidebar-menu">
        {menuItems.map((item, idx) => (
          <li
            key={idx}
            style={{ '--sb-i': idx }}
            className={location.pathname === item.path ? 'active' : ''}
          >
            <Link
              to={item.path}
              onClick={onClose}
              onMouseEnter={() => prefetchLinkTarget(item.path, activeLibraryId)}
              onFocus={() => prefetchLinkTarget(item.path, activeLibraryId)}
              onTouchStart={() => prefetchLinkTarget(item.path, activeLibraryId)}
            >
              {item.icon && (
                <i
                  className={item.icon}
                  style={{ width: 20, marginRight: 10, textAlign: 'center', fontSize: 14, opacity: 0.95 }}
                />
              )}
              <span className="sb-label">{item.label}</span>
            </Link>
          </li>
        ))}
      </ul>

      {/* Sidebar Footer */}
      {isSidebarOpen && (
        <div className="sidebar-footer">
          {libraryId && (
            <div className="library-info">
              {/* Library ID: {libraryId} */}
            </div>
          )}
          {/* <button className="logout-button" onClick={handleLogout}>
            Logout
          </button> */}
        </div>
      )}
    </div>
  );
};

export default Sidebar;

